import {
  orderSourceKey,
  orderTypeKey,
  mealTypeKey,
  shippingMethodKey,
  tableNumKey,
  orderCartKey,
  orderMoreCartKey,
  orderDetailKey,
  orderRelatedBuzIdKey,
  orderBillTypeKey,
  orderPreferenceKey,
  sessionDateKey,
} from '@/configs/main';
import { OrderSourceType, OrderType, ShippingMethod } from '@/enums';
import {
  getCurrentMerchantId,
  getCurrentBranchId,
  getCurrentStore,
} from '@/helpers/Utils';

export const getOrderSource = () => {
  let data = OrderSourceType.ONLINE;
  try {
    if (localStorage.getItem(orderSourceKey)) {
      data = parseInt(localStorage.getItem(orderSourceKey), 10);
    }
  } catch (error) {
    console.log('>>> src/helpers/Utils.js -> getOrderSource error:', error);
  }
  return data;
};

export const setOrderSource = (payload) => {
  try {
    localStorage.setItem(orderSourceKey, payload);
  } catch (error) {
    console.log('>>> src/helpers/Utils.js -> setOrderSource error:', error);
  }
};

export const getOrderType = () => {
  let data = OrderType.FnB;
  try {
    if (localStorage.getItem(orderTypeKey)) {
      data = parseInt(localStorage.getItem(orderTypeKey), 10);
    }
  } catch (error) {
    console.log('>>> src/helpers/Utils.js -> getOrderType error:', error);
  }
  return data;
};

export const setOrderType = (payload) => {
  try {
    localStorage.setItem(orderTypeKey, payload);
  } catch (error) {
    console.log('>>> src/helpers/Utils.js -> setOrderType error:', error);
  }
};

export const getMealType = () => {
  let data = null;
  try {
    if (localStorage.getItem(mealTypeKey)) {
      data = parseInt(localStorage.getItem(mealTypeKey), 10);
    }
  } catch (error) {
    console.log('>>> src/helpers/Utils.js -> getMealType error:', error);
  }
  return data;
};

export const setMealType = (payload) => {
  try {
    if (payload) {
      localStorage.setItem(mealTypeKey, payload);
    } else {
      localStorage.removeItem(mealTypeKey);
    }
  } catch (error) {
    console.log('>>> src/helpers/Utils.js -> setMealType error:', error);
  }
};

export const getShippingMethod = () => {
  let data = ShippingMethod.PICKUP;
  try {
    if (localStorage.getItem(shippingMethodKey)) {
      data = parseInt(localStorage.getItem(shippingMethodKey), 10);
    }
  } catch (error) {
    console.log('>>> src/helpers/Utils.js -> getShippingMethod error:', error);
  }
  return data;
};

export const setShippingMethod = (payload) => {
  try {
    if (payload) {
      localStorage.setItem(shippingMethodKey, payload);
    } else {
      localStorage.removeItem(shippingMethodKey);
    }
  } catch (error) {
    console.log('>>> src/helpers/Utils.js -> setShippingMethod error:', error);
  }
};

export const getTableNum = () => {
  let data = null;
  try {
    data = localStorage.getItem(tableNumKey);
  } catch (error) {
    console.log('>>> src/helpers/Utils.js -> getTableNum error:', error);
  }
  return data;
};

export const setTableNum = (payload) => {
  try {
    if (payload) {
      localStorage.setItem(tableNumKey, payload);
    } else {
      localStorage.removeItem(tableNumKey);
    }
  } catch (error) {
    console.log('>>> src/helpers/Utils.js -> setTableNum error:', error);
  }
};

export const getOrderCart = (mid, bid, s) => {
  let data = null;
  try {
    const key = `${orderCartKey}_${mid}_${bid}_${s}`;
    if (localStorage.getItem(key)) {
      data = JSON.parse(localStorage.getItem(key));
    }
  } catch (error) {
    console.log('>>> src/helpers/Utils.js -> getOrderCart error:', error);
  }
  return data;
};

export const setOrderCart = (mid, bid, s, cart) => {
  try {
    const key = `${orderCartKey}_${mid}_${bid}_${s}`;
    if (cart) {
      localStorage.setItem(key, JSON.stringify({ ...cart, s, mid, bid }));
    } else {
      localStorage.removeItem(key);
    }
  } catch (error) {
    console.log('>>> src/helpers/Utils.js -> setOrderCart error:', error);
  }
};

export const getOrderCartSpecial = (mid, bid, s) => {
  let data = null;
  try {
    const key = `${orderCartKey}_${mid}_${bid}_${s}_s`;
    if (localStorage.getItem(key)) {
      data = JSON.parse(localStorage.getItem(key));
    }
  } catch (error) {
    console.log('>>> src/helpers/Utils.js -> getOrderCart error:', error);
  }
  return data;
};

export const setOrderCartSpecial = (mid, bid, s, cart) => {
  try {
    const key = `${orderCartKey}_${mid}_${bid}_${s}_s`;
    if (cart) {
      localStorage.setItem(key, JSON.stringify({ ...cart, s, mid, bid }));
    } else {
      localStorage.removeItem(key);
    }
  } catch (error) {
    console.log('>>> src/helpers/Utils.js -> setOrderCart error:', error);
  }
};

export const getOrderMoreCart = (mid, bid, s) => {
  let data = null;
  try {
    const key = `${orderMoreCartKey}_${mid}_${bid}_${s}`;
    if (localStorage.getItem(key)) {
      data = JSON.parse(localStorage.getItem(key));
    }
  } catch (error) {
    console.log('>>> src/helpers/Utils.js -> getOrderMoreCart error:', error);
  }
  return data;
};

export const setOrderMoreCart = (mid, bid, s, cart) => {
  try {
    const key = `${orderMoreCartKey}_${mid}_${bid}_${s}`;
    if (cart) {
      localStorage.setItem(key, JSON.stringify({ ...cart, s, mid, bid }));
    } else {
      localStorage.removeItem(key);
    }
  } catch (error) {
    console.log('>>> src/helpers/Utils.js -> setOrderMoreCart error:', error);
  }
};

export const getOrderDetail = () => {
  let data = null;
  try {
    if (localStorage.getItem(orderDetailKey)) {
      data = JSON.parse(localStorage.getItem(orderDetailKey));
    }
  } catch (error) {
    console.log('>>> src/helpers/Utils.js -> getOrderDetailCart error:', error);
  }
  return data;
};

export const setOrderDetail = (payload) => {
  try {
    if (payload) {
      localStorage.setItem(orderDetailKey, JSON.stringify(payload));
    } else {
      localStorage.removeItem(orderDetailKey);
    }
  } catch (error) {
    console.log('>>> src/helpers/Utils.js -> setOrderDetailCart error:', error);
  }
};

export const getOrderRelatedBuzId = () => {
  let data = null;
  try {
    data = localStorage.getItem(orderRelatedBuzIdKey);
  } catch (error) {
    console.log(
      '>>> src/helpers/Utils.js -> getOrderRelatedBuzId error:',
      error
    );
  }
  return data;
};

export const setOrderRelatedBuzId = (payload) => {
  try {
    if (payload) {
      localStorage.setItem(orderRelatedBuzIdKey, payload);
    } else {
      localStorage.removeItem(orderRelatedBuzIdKey);
    }
  } catch (error) {
    console.log(
      '>>> src/helpers/Utils.js -> setOrderRelatedBuzId error:',
      error
    );
  }
};

export const getOrderBillType = () => {
  let data = 1;
  try {
    if (localStorage.getItem(orderBillTypeKey)) {
      data = parseInt(localStorage.getItem(orderBillTypeKey), 10);
    }
  } catch (error) {
    console.log('>>> src/helpers/Utils.js -> getOrderBillType error:', error);
  }
  return data;
};

export const setOrderBillType = (payload) => {
  try {
    if (payload) {
      localStorage.setItem(orderBillTypeKey, payload);
    } else {
      localStorage.removeItem(orderBillTypeKey);
    }
  } catch (error) {
    console.log('>>> src/helpers/Utils.js -> setOrderBillType error:', error);
  }
};

export const getOrderPreference = () => {
  let data = {};
  try {
    if (localStorage.getItem(orderPreferenceKey)) {
      data = JSON.parse(localStorage.getItem(orderPreferenceKey));
    }
  } catch (error) {
    console.log('>>> src/helpers/Utils.js -> getOrderPreference error:', error);
  }
  return data;
};

export const setOrderPreference = (payload) => {
  try {
    if (payload) {
      localStorage.setItem(orderPreferenceKey, JSON.stringify(payload));
    } else {
      localStorage.removeItem(orderPreferenceKey);
    }
  } catch (error) {
    console.log('>>> src/helpers/Utils.js -> setOrderPreference error:', error);
  }
};

export const checkSessionDate = (id, mid, bid) => {
  // 获取当前时间
  const currentTime = new Date().getTime();

  // 从 localStorage 中获取存储的时间
  const storedTime = localStorage.getItem(sessionDateKey);
  const curStore = getCurrentStore();
  const merchantId = getCurrentMerchantId();
  const branchId = getCurrentBranchId();
  const source = getOrderSource();

  if (storedTime) {
    // 计算时间差（毫秒）
    const timeDifference = currentTime - parseInt(storedTime, 10);
    // 如果时间差超过一小时（3600000 毫秒）/ 切换了商户 / 切换了店铺
    if (
      timeDifference > 3600000 ||
      (mid && mid !== merchantId) ||
      (bid && bid !== branchId) ||
      (id && id !== curStore.id)
    ) {
      // 重新保存当前时间
      localStorage.setItem(sessionDateKey, currentTime.toString());
      // setCurrentUser(null); // 清除登录信息
      setOrderCart(merchantId, branchId, source, null); // 清除购物车
      setOrderCartSpecial(merchantId, branchId, source, null); // 清除购物车
      console.log('时间超过一小时，已重新保存时间。');
    } else {
      console.log('时间未超过一小时，已重新保存时间。');
      localStorage.setItem(sessionDateKey, currentTime.toString()); // 续Session时间
    }
  } else {
    // 如果没有存储的时间，则保存当前时间
    localStorage.setItem(sessionDateKey, currentTime.toString());
    // setCurrentUser(null); // 清除历史登录信息
    setOrderCart(merchantId, branchId, source, null); // 清除历史购物车
    setOrderCartSpecial(merchantId, branchId, source, null); // 清除历史购物车
    console.log('首次访问，已保存时间。');
  }
};
